export default "__VITE_ASSET__D8Wp_jg1__"